<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal
        size="md" :visible="modal.show" :data="model" :show-confirmation="showConfirmation" :ok-title="$t('Submit')"
        :title="model.uuid ? $t(`Update County`) : $t(`Create New County`)" :is-loading="loading" scrollable
        @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="name"/>
        </div>
        <div class="col-md-12">
          <state-input-widget :model="model" attribute="state_uuid" :items="states"/>
        </div>
        <div class="col-md-12">
          <percentage-input-widget :model="model" attribute="tax_rate"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="exclude_tax_for_premium" type="checkbox"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import PercentageInputWidget from "../../../core/widgets/PercentageInputWidget";
  import CountyModel from "./models/County.model";
  import StateInputWidget from "../../../core/widgets/StateInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('setup/salesTaxConfiguration');
  export default {
    name: "CountyModal",
    components: {
      StateInputWidget,
      PercentageInputWidget,
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new CountyModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.county.modal,
        editObject: state => state.county.modal.object,
        states: state => state.state.countryStates,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.state_uuid)) {
          this.model = new CountyModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideCountyModal', 'createCounty', 'updateCounty']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new CountyModel();
        this.hideCountyModal();
      },
      async onSubmit() {
        this.loading = true;

        const isUpdate = !!this.model.uuid;
        const params = _.cloneDeep(this.model.toJSON());
        let response;

        if (isUpdate) {
          response = await this.updateCounty(params);
        } else {
          response = await this.createCounty(params);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideCountyModal();
          if (isUpdate) {
            this.$toast('success', this.$t('County was successfully updated'));
          } else {
            this.$toast('success', this.$t('County was successfully created'));
          }
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>